import { createTheme } from "@mui/material/styles";

export const shades = {
  primary: {
    100: "#cccccc",
    200: "#999999",
    300: "#666666",
    400: "#333333",
    500: "#000000",
    600: "#000000",
    700: "#000000",
    800: "#000000",
    900: "#000000",
  },
  blue: {
    100: "#d1dbf3",
    200: "#a3b7e6",
    300: "#7592da",
    400: "#476ecd",
    500: "#194ac1",
    600: "#143b9a",
    700: "#0f2c74",
    800: "#0a1e4d",
    900: "#050f27",
  },
  red: {
    100: "#f7ccd2",
    200: "#ef99a4",
    300: "#e66677",
    400: "#de3349",
    500: "#d6001c",
    600: "#ab0016",
    700: "#800011",
    800: "#56000b",
    900: "#2b0006",
  },
  green: {
    100: "#e2f8dd",
    200: "#c5f1bb",
    300: "#a7e99a",
    400: "#8ae278",
    500: "#6ddb56",
    600: "#57af45",
    700: "#418334",
    800: "#2c5822",
    900: "#162c11",
  },
  neutral: {
    100: "#fdfdfd",
    200: "#fbfbfb",
    300: "#f8f8f8",
    400: "#f6f6f6",
    500: "#f4f4f4",
    600: "#c3c3c3",
    700: "#929292",
    800: "#626262",
    900: "#313131",
  },
};

export const theme = createTheme({

  //POR AGREGAR BREAKPOINTS
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 375, 
  //     md: 768,
  //     lg: 1024,
  //     xl: 1440,
  //   },
  // },

  palette: {
    primary: {
      main: shades.primary[500],
      light: '#0d91ff',  // Azul brillante
      normal: '#0030e8',   // Azul medio
      dark: '#000079',   // Azul marino
      deep: '#00003d',   // Azul muy oscuro/Negro azulado
    },
    secondary: {
      main: shades.blue[800],
      success: '#15ce21',  // Verde
      highlight: '#ffda00', // Amarillo
      accent: '#e84f98',    // Rosa/Fucsia
    },
    neutral: {
      dark: shades.neutral[700],
      main: shades.neutral[500],
      light: shades.neutral[100],
    },
  },
  typography: {
    fontFamily: ["Cqsr_text", "sans-serif"].join(","),
    fontSize: 11,
    h1: {
      fontFamily: ["Cqsr_title", "sans-serif"].join(","),
      fontSize: 48,
    },
    h2: {
      fontFamily: ["Cqsr_title", "sans-serif"].join(","),
      fontSize: 36,
    },
    h3: {
      fontFamily: ["Cqsr_title", "sans-serif"].join(","),
      fontSize: 20,
    },
    h4: {
      fontFamily: ["Cqsr_title", "sans-serif"].join(","),
      fontSize: 24,
    },
    h5: {
      fontFamily: ["Cqsr_title", "sans-serif"].join(","),
      fontSize: 20,
    },
    h6: {
      fontFamily: ["Cqsr_title", "sans-serif"].join(","),
      fontSize: 16,
    },
  },

  components: {
    MuiToolbar: {
      styleOverrides: {
        root: {
          '@media (min-width: 600px)': {
            paddingLeft: '16px',
            paddingRight: '16px',
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width: 600px)': {
            paddingLeft: '16px',
            paddingRight: '16px',
          }
        }
      }
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '9px', 
        },
      },
    }
  },
});
